export {default as roll} from './roll/roll'
export {default as pos} from './pos/pos'
export {default as prev} from './prev/prev'
export {default as rew} from './rew/rew'
export {default as play} from './play/play'
export {default as stop} from './stop/stop'
export {default as fwd} from './fwd/fwd'
export {default as next} from './next/next'
export {default as insert} from './insert/insert'
export {default as loop} from './loop/loop'
export {default as download} from './download/download'



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/buttons.js